import api from '../../../../App/socket';

export const getUserProfileEmails = _id => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'Read',
        options: {
            limit: 1,
            where: { _id },
            attributes: ['person.emails.name', 'person.emails.email', 'person.emails._id'],
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_emails_requests/get_user_email_request.js